/**
 * Onboarding tour step definitions per persona.
 * Selectors must point to elements that exist immediately after dashboard load.
 */
export const FRANQUEADO_STEPS = [
  {
    selector: "[data-testid=fr-sidebar], [data-testid=fr-mobile-menu-btn]",
    title: "Bem-vindo(a) ao Centro de Controle 👑",
    body: "Aqui você administra toda a sua cidade: lojas, entregadores, pedidos e financeiro num único painel em tempo real.",
    placement: "auto",
  },
  {
    selector: "[data-testid=fr-live-orders], [data-testid=fr-topbar-city]",
    title: "KPIs ao vivo da cidade",
    body: "Pedidos, faturamento, comissão e entregadores online — atualizados a cada 15s para você nunca perder o pulso da operação.",
    placement: "bottom",
  },
  {
    selector: "[data-testid=fr-nav-stores]",
    title: "Cadastre e aprove lojas",
    body: "Toda nova loja da sua cidade passa por aqui. Você ativa, suspende e acompanha o desempenho de cada estabelecimento.",
    placement: "auto",
  },
  {
    selector: "[data-testid=fr-nav-orders]",
    title: "Pedidos em tempo real",
    body: "Visualize todos os pedidos da cidade e intervenha quando preciso (atraso, cancelamento, suporte ao cliente).",
    placement: "auto",
  },
  {
    selector: "[data-testid=fr-nav-finance]",
    title: "Sua carteira inteligente",
    body: "Comissões de cada loja, saldos liberados e saques via PIX. Tudo conciliado automaticamente pelo sistema.",
    placement: "auto",
  },
  {
    selector: "[data-testid=fr-nav-chat]",
    title: "Chat direto com sua rede",
    body: "Converse 1-a-1 com lojistas e entregadores da cidade pelo chat profissional. Resposta rápida = retenção alta.",
    placement: "auto",
  },
];

export const LOJISTA_STEPS = [
  {
    selector: "[data-testid=loja-shell-topbar], [data-testid=loja-mobile-menu-btn], header",
    title: "Bem-vindo(a) à sua Loja 🍔",
    body: "Este é o painel onde você toca o seu restaurante: pedidos, cardápio, financeiro e relacionamento com clientes.",
    placement: "bottom",
  },
  {
    selector: "[data-testid=nav-orders], a[href='/loja/pedidos']",
    title: "Pedidos chegam aqui",
    body: "Cada pedido novo aparece em tempo real com som. Aceite, prepare e acompanhe até a entrega.",
    placement: "auto",
  },
  {
    selector: "a[href='/loja/cozinha'], [data-testid=nav-kitchen]",
    title: "Modo Cozinha",
    body: "Tela otimizada para o operador da cozinha: pedidos em colunas, tempos e status. Reduz erros e atrasos.",
    placement: "auto",
  },
  {
    selector: "a[href='/loja/produtos'], [data-testid=nav-products]",
    title: "Cadastre seu cardápio",
    body: "Adicione produtos com fotos, preços, variações e disponibilidade. Quanto mais completo, mais converte.",
    placement: "auto",
  },
  {
    selector: "a[href='/lojista/chat'], [data-testid=nav-franchise-chat]",
    title: "Chat com a Franquia",
    body: "Tire dúvidas, peça materiais e fale com o franqueado da sua cidade direto pelo app.",
    placement: "auto",
  },
  {
    selector: "a[href='/loja/carteira'], [data-testid=nav-wallet]",
    title: "Carteira e Saques",
    body: "Seus ganhos liberados a cada 7 dias, com saque PIX instantâneo. Acompanhe taxas e extratos detalhados.",
    placement: "auto",
  },
];
